
import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'CopyrightFooter'
})
export default class CopyrightFooter extends Vue {}
